const toFeatureClass = (name, feature) => feature ? `with-${name}` : void 0;
export {
  toFeatureClass
};
//# sourceMappingURL=toFeatureClass.js.map
